"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var deferredPrompt = null;
var listeners = new Set();
var setDeferredPrompt = function (event) {
    deferredPrompt = event;
    listeners.forEach(function (listener) { return listener(); });
};
// registered at module load since the event can fire before any component mounts
window.addEventListener('beforeinstallprompt', function (event) { return setDeferredPrompt(event); });
window.addEventListener('appinstalled', function () { return setDeferredPrompt(null); });
var subscribe = function (onStoreChange) {
    listeners.add(onStoreChange);
    return function () {
        listeners.delete(onStoreChange);
    };
};
var getSnapshot = function () { return deferredPrompt; };
var install = function () {
    deferredPrompt === null || deferredPrompt === void 0 ? void 0 : deferredPrompt.prompt().catch(console.error);
    // a prompt event can only be used once, the browser fires a new one if the user dismisses it
    setDeferredPrompt(null);
};
var useInstallPrompt = function () {
    var prompt = (0, react_1.useSyncExternalStore)(subscribe, getSnapshot);
    return prompt !== null ? install : null;
};
exports.default = useInstallPrompt;
